import * as React from 'react';
import { IgcTileManagerComponent as Component } from 'igniteui-webcomponents';
import type { IgcTileComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * The tile manager component enables the dynamic arrangement, resizing, and interaction of tiles.
 * @slot  - Default slot for the tile manager. Only `igc-tile` elements will be projected inside the CSS grid container.
 * @csspart base - The tile manager CSS Grid container.
 * @cssproperty --column-count - The number of columns for the tile manager. The `column-count` attribute sets this variable.
 * @cssproperty --min-col-width - The minimum size of the columns in the tile-manager. The `min-column-width` attribute sets this variable.
 * @cssproperty --min-row-height - The minimum size of the rows in the tile-manager. The `min-row-height` attribute sets this variable.
 * @cssproperty --grid-gap - The gap size of the underlying CSS grid container. The `gap` attributes sts this variable.
 * @class
 */
export const IgrTileManager = /* @__PURE__ */ createComponent({
  tagName: 'igc-tile-manager',
  displayName: 'IgrTileManager',
  elementClass: Component,
  react: React,
  events: {
    onTileFullscreen: 'igcTileFullscreen' as EventName<
      IgcTileComponentEventMap['igcTileFullscreen']
    >,
    onTileMaximize: 'igcTileMaximize' as EventName<
      IgcTileComponentEventMap['igcTileMaximize']
    >,
    onTileDragStart: 'igcTileDragStart' as EventName<
      IgcTileComponentEventMap['igcTileDragStart']
    >,
    onTileDragEnd: 'igcTileDragEnd' as EventName<
      IgcTileComponentEventMap['igcTileDragEnd']
    >,
    onTileDragCancel: 'igcTileDragCancel' as EventName<
      IgcTileComponentEventMap['igcTileDragCancel']
    >,
    onTileResizeStart: 'igcTileResizeStart' as EventName<
      IgcTileComponentEventMap['igcTileResizeStart']
    >,
    onTileResizeEnd: 'igcTileResizeEnd' as EventName<
      IgcTileComponentEventMap['igcTileResizeEnd']
    >,
    onTileResizeCancel: 'igcTileResizeCancel' as EventName<
      IgcTileComponentEventMap['igcTileResizeCancel']
    >,
  },
});

export type IgrTileManager = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrTileManagerModule = Component;
